import { gql } from '@apollo/client';

export const EXCHANGE_TOKEN = gql`
  query Flex_ExchangeToken($loginToken: String!) {
    tokenExchange(loginToken: $loginToken) {
      token
    }
  }
`;
